import { COLOR } from 'vars/index'

export const DividerColors = {
  TEXT_ICON_SECONDARY: COLOR.TEXT_ICON_SECONDARY,
  ACCENT_SECONDARY: COLOR.ACCENT_SECONDARY,
  SURFACE_OPACITY_LIGHT_20: COLOR.SURFACE_OPACITY_LIGHT_20,
  SURFACE_OPACITY_LIGHT_10: COLOR.SURFACE_OPACITY_LIGHT_10,
} as const
export type DividerColors = (typeof DividerColors)[keyof typeof DividerColors]

export const DividerFluid = {
  Vertical: 'vertical',
  Horizontal: 'horizontal',
  Both: 'both',
  None: 'none',
} as const
export type DividerFluid = (typeof DividerFluid)[keyof typeof DividerFluid]
